module.exports = __webpack_public_path__ + "img/face96.2a811b38.gif";